import React, {useEffect, useState} from 'react'
import {IonContent, IonModal, IonPage} from '@ionic/react'
import {useHistory} from 'react-router-dom'
import {config} from '../Constants'
import ContactCard from "./ContactCard"
import {ApiService} from "../api/ApiService";
import {userStore} from "../api/AuthService";
import {DriverManager} from "../api/model/DriverManager";
import LoadSelectionFirstIn from '../components/walkthrough/individualPage/LoadSelectionIn'
import {toastStore} from '../components/AppToast'
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader'
import { useLogPageVisit } from '../utils/logPageVisit'
import {ChevronRight, CloseIcon} from '../components/icons'

type Load = {
    consigneeCity: string
    consigneeCode: string
    consigneeState: string
    deadhead: string
    deliveryEndTime: string
    deliveryStartTime: string
    dispatch: string
    miles: string
    orderNumber: string
    pickupEndTime: string
    pickupStartTime: string
    shipperCity: string
    shipperCode: string
    shipperState: string
}

const LoadSelection: React.FC = () => {
    useLogPageVisit('LP Checked Loads', 'User checked their load boards');
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const [mounted, setMounted] = useState(false);

    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [loads, setLoads] = useState<any>([]);
    const [selectedLoad, setSelectedLoad] = useState<any>({});
    const [scarcityMode, setScarcityMode] = useState('0');
    const [noPrePlanned, setNoPrePlanned] = useState(false);
    const [notModeled, setNotModeled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dm, setDM] = useState<DriverManager>({} as DriverManager);

    useEffect(() => {
      const id = requestAnimationFrame(() => {
        setTimeout(() => setMounted(true), 30);
      });
      return () => cancelAnimationFrame(id);
    }, []);

    useEffect(() => {
        ApiService.getUserState('Load', {name: 'scarcityMode', userId: 0}).then(it => setScarcityMode(it.value));
        ApiService.topLoadsGet('load selection', {unit: userStore.getState().driver!.unit}).then(it => {
            if (it.loads.error === 'Unit already planned') {
                setNoPrePlanned(true);
                setLoads(['loaded']);
            } else if (it.loads.error === 'Unit not modeled') {
                setNotModeled(true);
                setLoads(['notModeled']);
            } else {
                parseOrders(it.loads.orders);
            }
        })
        .catch(() => {
            toastStore.getState().setToast('There was an error loading your load boards. Please check your connection and try again.');
        });
        ApiService.getDriverManager('load selection', {dmCode: localStorage.getItem('dmCode')!}).then(it => setDM(it));
    }, []);

    async function parseOrders(orders: any) {
        let tempArray: Load[] = []
        if (!orders || orders.length === 0) {
            setNotModeled(true);
            setLoads(['notModeled']);
            return;
        }
        if (orders[0].orderNumber === 'WAIT') orders.shift();
        for (let i = 0; i < 3 && typeof orders[i] !== 'undefined'; i++) {
            if (orders[i].orderNumber !== 'WAIT' && orders[i].orderNumber !== 'HOME') {
                orders[i].details.pickupStartDate =
                await convertDOYtoSQL(orders[i].details.pickupStartDate)
                orders[i].details.pickupEndDate =
                await convertDOYtoSQL(orders[i].details.pickupEndDate)
                orders[i].details.deliveryStartDate =
                await convertDOYtoSQL(orders[i].details.deliveryStartDate)
                orders[i].details.deliveryEndDate =
                await convertDOYtoSQL(orders[i].details.deliveryEndDate)
                orders[i].details.pickupStartTime =
                orders[i].details.pickupStartTime.slice(0, 2) + ':' + orders[i].details.pickupStartTime.slice(2)
                orders[i].details.pickupEndTime =
                orders[i].details.pickupEndTime.slice(0, 2) + ':' + orders[i].details.pickupEndTime.slice(2)
                orders[i].details.deliveryStartTime =
                orders[i].details.deliveryStartTime.slice(0, 2) + ':' + orders[i].details.deliveryStartTime.slice(2)
                orders[i].details.deliveryEndTime =
                orders[i].details.deliveryEndTime.slice(0, 2) + ':' + orders[i].details.deliveryEndTime.slice(2)
                orders[i].details.weight = orders[i].details.weight.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                tempArray.push(orders[i])
            } else if ((orders[i].orderNumber === 'WAIT' || orders[i].orderNumber === 'HOME') && orders.length === 1) {
                tempArray.push(orders[i]);
                setNotModeled(true);
            }
        }
        if (tempArray.length === 0) {
            setNotModeled(true);
            setLoads(['notModeled']);
            return;
        }
        setLoads(tempArray)
    }

    function convertDOYtoSQL(yyyyddd: any) {
        const year = parseInt(yyyyddd.toString().substring(0, 4), 10);
        const dayOfYear = parseInt(yyyyddd.toString().substring(4), 10);
        const date = new Date(year, 0, dayOfYear);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function acceptLoad(order: string, dispatch: string) {
        if (isLoading) return;
        setIsLoading(true);
        setShowModal2(false);
        setShowModal3(true);
        var data = new FormData()
        data.append("payload", JSON.stringify({ cmds: [{cmd: "topLoadAccept", args: {unit: userStore.getState().driver!.unit, orderNumber: order, dispatch: dispatch, loginToken: localStorage.getItem('token')}}] }))
        const requestOptions = {
          method: 'POST',
          headers: {},
          body: data
        };
        fetch(config.url.BASE_URL, requestOptions)
        .then(response => response.json())
        .then(json => {
            if (json.results[0].errcode === 'NOTLOGGEDIN') {
                localStorage.removeItem('token');
                setShowModal3(false);
                toastStore.getState().setToast('Your session has expired. Please log in again.');
            }
            setIsLoading(false);
        })
        .catch(() => {
            setShowModal3(false);
            setIsLoading(false);
            toastStore.getState().setToast('Your load could not be accepted. Please check your connection and try again.');
        });
    }

    const goBack = () => {
      if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    const isBusy = noPrePlanned || notModeled;
    const heroMeta = noPrePlanned
      ? 'You are already on the road with a load.'
      : notModeled
      ? 'Not currently available for your unit.'
      : loads.length === 0
      ? 'Loading your load board…'
      : `${loads.length} load${loads.length === 1 ? '' : 's'} available`;

    return (
        <LoadSelectionFirstIn>
        <IonPage>
            <LoadDetailHeader title="Select Load" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Load Board</div>
                  <div className="advance-hero__title home-display">Select Load</div>
                  <div className="advance-hero__meta">{heroMeta}</div>
                </div>

                <div className="home-sheet advance-sheet">
                  {isBusy ? (
                    <div className="home-card training-info-card">
                      <div className="training-info-card__label">{noPrePlanned ? 'Already Loaded' : 'Not Available'}</div>
                      <p className="training-info-card__body">
                        {noPrePlanned
                          ? 'You are already on the road with a load. Check back here after to get a new one!'
                          : 'This feature is not currently available for your unit. Please try again later.'}
                      </p>
                    </div>
                  ) : loads.length === 0 ? (
                    <div className="home-card training-info-card">
                      <div className="training-info-card__label">Loading</div>
                      <p className="training-info-card__body">Loading your load board…</p>
                    </div>
                  ) : (
                    loads.map((element: any, idx: number) => (
                      <div className="home-card load-select-card" key={element.orderNumber || idx}>
                        <div className="load-select-card__header">
                          <span className="load-select-card__order">Order #{element.orderNumber}</span>
                        </div>

                        <div className="load-select-card__route">
                          <div className="load-select-card__stop">
                            <span className="load-select-card__stop-label">Origin</span>
                            <span className="load-select-card__stop-place">{element.details.shipperCity} | {element.details.shipperState}</span>
                          </div>
                          <span className="load-select-card__arrow" aria-hidden="true"><ChevronRight /></span>
                          <div className="load-select-card__stop">
                            <span className="load-select-card__stop-label">Destination</span>
                            <span className="load-select-card__stop-place">{element.details.consigneeCity} | {element.details.consigneeState}</span>
                          </div>
                        </div>

                        <div className="load-select-card__times">
                          <div className="load-select-card__time">
                            <span className="load-select-card__time-label">Pickup</span>
                            <span className="load-select-card__time-value">{element.details.pickupStartDate} | {element.details.pickupStartTime} CST</span>
                          </div>
                          <div className="load-select-card__time">
                            <span className="load-select-card__time-label">Delivery</span>
                            <span className="load-select-card__time-value">{element.details.deliveryStartDate} | {element.details.deliveryStartTime} CST</span>
                          </div>
                        </div>

                        <div className="load-select-card__actions">
                          <button
                            type="button"
                            className="profile-submit"
                            onClick={() => {
                              setShowModal2(true);
                              setSelectedLoad(element);
                            }}
                          >
                            {scarcityMode === '0' ? 'Accept' : 'Request'}
                          </button>
                          <button
                            type="button"
                            className="training-secondary-btn"
                            onClick={() => {
                              setShowModal1(true);
                              setSelectedLoad(element);
                            }}
                          >
                            Details
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </IonContent>

            <IonModal isOpen={showModal1} onDidDismiss={() => setShowModal1(false)}>
              <div className="design-a design-a--mounted">
                <div className="training-modal">
                  <div className="training-modal__header">
                    <span>Order #{selectedLoad.orderNumber}</span>
                    <button
                      type="button"
                      className="modal-close-btn training-modal__close"
                      onClick={() => setShowModal1(false)}
                      aria-label="Close"
                    >
                      <CloseIcon size={18} color="#1a1a1a" />
                    </button>
                  </div>

                  <div className="training-course-info">
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Pick Up</span>
                      <span className="training-course-info__value">{selectedLoad.details?.pickupStartDate} | {selectedLoad.details?.pickupStartTime} CST</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Drop Off</span>
                      <span className="training-course-info__value">{selectedLoad.details?.deliveryStartDate} | {selectedLoad.details?.deliveryStartTime} CST</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Origin</span>
                      <span className="training-course-info__value">{selectedLoad.details?.shipperCity} | {selectedLoad.details?.shipperState}</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Destination</span>
                      <span className="training-course-info__value">{selectedLoad.details?.consigneeCity} | {selectedLoad.details?.consigneeState}</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Loaded Miles</span>
                      <span className="training-course-info__value">{parseInt(selectedLoad?.miles) || 0} mi</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Empty Miles</span>
                      <span className="training-course-info__value">{parseInt(selectedLoad?.deadhead) || 0} mi</span>
                    </div>
                    <div className="training-course-info__row">
                      <span className="training-course-info__label">Weight</span>
                      <span className="training-course-info__value">{selectedLoad.details?.weight} lbs</span>
                    </div>
                  </div>
                </div>
              </div>
            </IonModal>

            <IonModal isOpen={showModal2} onDidDismiss={() => setShowModal2(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  {scarcityMode === '0' ? (
                    <>
                      <div className="roadtest-confirm-modal__title">Accept This Load?</div>
                      <p className="roadtest-confirm-modal__body">
                        This will start the planning process for Order #{selectedLoad.orderNumber}. Are you sure you want to accept it?
                      </p>
                      <button
                        type="button"
                        className="profile-submit"
                        onClick={() => acceptLoad(selectedLoad.orderNumber, selectedLoad.dispatch)}
                      >
                        Accept
                      </button>
                      <button type="button" className="roadtest-confirm-modal__secondary" onClick={() => setShowModal2(false)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <div className="roadtest-confirm-modal__title">Contact Your Carrier Agent</div>
                      <p className="roadtest-confirm-modal__body">
                        Please contact your carrier agent to get a new load. They can be reached with the information below.
                      </p>
                      {typeof dm.firstName !== 'undefined' ? (
                        <ContactCard contact={{name: dm.firstName + " " + dm.lastName, email: dm.email, subcategory: "Driver Agent", phone: dm.phone}}/>
                      ) : null}
                      <button type="button" className="roadtest-confirm-modal__secondary" onClick={() => setShowModal2(false)}>Close</button>
                    </>
                  )}
                </div>
              </div>
            </IonModal>

            <IonModal isOpen={showModal3} id="transparent">
              {isLoading ? (
                <div className="modal-div">
                  <div id="modal">
                    <div className="loading-div">
                      <p>Please wait... your load is being accepted.</p>
                      <div className="snippet" data-title=".dot-flashing" style={{margin: "4px 16px"}}>
                        <div className="stage">
                          <div className="dot-flashing"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="design-a">
                  <div className="roadtest-confirm-modal">
                    <div className="roadtest-confirm-modal__title">Success!</div>
                    <p className="roadtest-confirm-modal__body">Load #{selectedLoad.orderNumber} has been accepted.</p>
                    <button type="button" className="profile-submit" onClick={() => setShowModal3(false)}>Done</button>
                  </div>
                </div>
              )}
            </IonModal>
        </IonPage>
        </LoadSelectionFirstIn>
    )
}

export default LoadSelection
